import React, { useState, useEffect, createRef } from 'react';
import { List, Modal, Button, Segment, Header, Divider, Message, Dropdown, Grid, Sticky, Ref, Rail } from 'semantic-ui-react';
import { InstrumentationCard } from '../cards/InstrumentationCard';
import { validateInsts, parseInstString, instrumentationCursorCap, isCursorAdding, addOrReplaceItemAt, deleteItemAt, constructInstrumentationString } from '../../util/InstStrings';

export const RuleEntry = ({label, model, color, fluid, instrumentMap, currentState, submit}) => {

  const [ newState, setNewState ] = useState({});
  const [ stateValid, setStateValid ] = useState(true);
  const [ cursor, setCursor ] = useState(0);
  const [ selectedInst, setSelectedInst] = useState({id: -1, name: ""});
  const [ modalOpen, setModalOpen ] = useState(false);

  useEffect(() => {
    setNewState(parseInstString(currentState));
  }, [currentState]);

  const instList = InstrumentationCard(newState, instrumentMap, cursor);

  const adding = isCursorAdding(newState, cursor);

  const handleIncrease = () => {
    if (cursor < instrumentationCursorCap(newState) - 1) {
      setCursor(cursor + 1);
    } else {
      setCursor(0);
    }
  };
  const increaseButton = <Button onClick={handleIncrease}>Move cursor down</Button>;

  const handleDecrease = () => {
    if (cursor > 0) {
      setCursor(cursor - 1);
    } else {
      setCursor(instrumentationCursorCap(newState) - 1)
    }
  };
  const decreaseButton = <Button onClick={handleDecrease}>Move cursor up</Button>;

  const handleDelete = () => {
    if (cursor === 0) {
      setNewState({});
      setStateValid(false);
    } else {
      const editedState = JSON.parse(JSON.stringify(newState));
      deleteItemAt(editedState, cursor);
      setNewState(editedState);
      setStateValid(validateInsts(editedState));
    }
  };
  const deleteButton = <Button onClick={handleDelete} disabled={adding}>Delete item at cursor</Button>;
  
  const handleAdd = () => {
    if (selectedInst.id >= 0) {
      const item = {
        type: "inst",
        id: selectedInst.id
      };

      const editedState = JSON.parse(JSON.stringify(newState));
      addOrReplaceItemAt(item, editedState, cursor);
      setNewState(editedState);
      setStateValid(validateInsts(editedState));
      if (cursor > 0) {
        setCursor(cursor + 1);
      }
    }
  };
  const addButton = <Button onClick={handleAdd} disabled={!adding}>Add selected {model === "voice-types" ? "voice type" : "instrument"} at cursor</Button>;

  const handleAddSet = (op) => {
    const item = {
      type: "set",
      items: [],
      operator: op
    };

    const editedState = JSON.parse(JSON.stringify(newState));
    addOrReplaceItemAt(item, editedState, cursor);
    setNewState(editedState);
    setStateValid(validateInsts(editedState));
    if (cursor > 0) {
      setCursor(cursor + 2);
    } else {
      setCursor(cursor + 1);
    }
  };
  const addAllOfButton = <Button onClick={() => handleAddSet("AND")} disabled={!adding}>Add ALL OF set at cursor</Button>;
  const addOneOfButton = <Button onClick={() => handleAddSet("OR")} disabled={!adding}>Add ONE OF set at cursor</Button>;
  const addSeqButton = <Button onClick={() => handleAddSet("THEN")} disabled={!adding}>Add SEQUENTIALLY set at cursor</Button>;

  const options = Object.keys(instrumentMap).map((k) => {
    return { text: instrumentMap[k].name, value: k, key: k};
  });
  const handleSelect = (e, {value}) => {
    setSelectedInst(instrumentMap[value]);
  }
  const instrumentDropdown = <Dropdown 
    options={options}
    placeholder={`Select ${model === "voice-types" ? "voice type" : "instrument"}`}
    search
    onChange={handleSelect}
    selection
  />;

  const buttons = (<div className="instrumentation-buttons">
    <div className="instrumentation-button">{decreaseButton}</div>
    <div className="instrumentation-button">{deleteButton}</div>
    <div className="instrumentation-button">
      <div>{instrumentDropdown}</div>
      <div>{addButton}</div>
    </div>
    <div className="instrumentation-button">{addAllOfButton}</div>
    <div className="instrumentation-button">{addOneOfButton}</div>
    <div className="instrumentation-button">{addSeqButton}</div>
    <div className="instrumentation-button">{increaseButton}</div>
  </div>);

  const debugMessage = adding ? <div>adding</div> : <div>editing</div>;

  return (
    <Modal
      trigger={<Button fluid={fluid}>{label}</Button>}
      className="rule-entry-modal"
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      onOpen={() => setModalOpen(true)}
    >
      <Modal.Header>
        <Header as='h3' className='subtitle' color={color}>{label}</Header>
      </Modal.Header>
      <Modal.Content scrolling>
        <Grid>
          <Grid.Row columns='two'>
            <Grid.Column>
              <Sticky offset={60}>
                {buttons}
              </Sticky>
            </Grid.Column>
            <Grid.Column>
              <List size='big'>
                {instList}
              </List>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button color='red' onClick={() => {
            setNewState(parseInstString(currentState));
            setStateValid(true);
            setModalOpen(false);
          }}>Discard changes</Button>
        <Button disabled={!stateValid} color='green' onClick={() => {
          setModalOpen(false); submit(constructInstrumentationString(newState))
          }}>Done</Button>
      </Modal.Actions>
    </Modal>
  );
};